import { render, staticRenderFns } from "./HrTrainServicePro.vue?vue&type=template&id=3f659431&scoped=true&"
import script from "./HrTrainServicePro.vue?vue&type=script&lang=js&"
export * from "./HrTrainServicePro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f659431",
  null
  
)

export default component.exports